import ModalPopup from 'components/ModalPopup/ModalPopup';
import  QuickStartModal from 'components/QuickStartModal/QuickStartModal';
import { ButtonStyles, ModalPopupSize } from 'lib/enums';
import Table from '../../components/Table/Table';
import { ProjectsInitialization } from './ProjectsInitialization'
import ValidationMessage from '../../components/ValidationMessage/ValidationMessage';
import Button from './../../components/Button/Button';


const Projects = () => {
    const {
        projectsData,
        handleAddProject,
        handleDeleteProjectRow,
        handleModalConfirmProjectDeletion,
        handleModalCancelProjectDeletion,
        handleDuplicateProjectRow,
        tableColumns,
        showModal,
        maxNameLength,
        hasNameError,
        handleValidationMessageCloseEvent,
        quickStart        
    } = ProjectsInitialization()   

    return (
        <div className="container msds-block-padding-small">
            <div className="row">
                <div className="col-12">
                    <h1 className="msds-text-header-1">Projects</h1>
                    {hasNameError && (
                        <div className="col-12">
                            <ValidationMessage
                                message={'Unable to post project as the name must be under ' + maxNameLength + ' characters.'}
                                handleCloseEvent={handleValidationMessageCloseEvent}
                            />
                        </div>
                    )}
                    {projectsData && (
                        <div className="row">
                            <Table
                                data={projectsData}
                                columns={tableColumns}
                                handleDeleteDataRow={handleDeleteProjectRow}
                                handleDuplicateRow={handleDuplicateProjectRow}
                                addButtonLabel="Add New Project"
                                addButtonLabelIcon="plus"
                                onAddButtonClick={handleAddProject}
                                customCssClasses='msds-table--projects'
                                customButtons={[ <Button
                                    id="xsd__e2e-quick-start-button"
                                    key="quick-start"
                                    label="Quick Start"
                                    onClickHandler={quickStart.openModal}
                                />,]}
                            />
                            <QuickStartModal
                                open={quickStart.open}
                                onClose={quickStart.closeModal}
                                onSubmit={quickStart.submit}
                                projectOptions={quickStart.projectOptions}
                                siteOptions={quickStart.siteOptions}
                                quickStartProjects={quickStart.quickStartProjects}
                            />
                            <ModalPopup
                                headline="Confirm Delete"
                                description="Are you sure you want to delete this row?"
                                size={ModalPopupSize.Small}
                                showModal={showModal}
                                onCloseButtonclick={handleModalCancelProjectDeletion}
                                button1Style={ButtonStyles.Danger}
                                button1Label="Yes, delete"
                                button1OnClickHandler={handleModalConfirmProjectDeletion}
                                button2Style={ButtonStyles.Tertiary}
                                button2Label="Cancel"
                                button2OnClickHandler={handleModalCancelProjectDeletion}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Projects;
